var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready && _vm.date && _vm.time
    ? _c("aside", { staticClass: "main" }, [
        _c(
          "button",
          {
            staticClass: "content",
            attrs: { type: "button" },
            on: { click: _vm.openScheduling },
          },
          [
            _c("span", { staticClass: "eyebrow" }, [
              _vm._v("Next Available Appointment"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "date" }, [_vm._v(_vm._s(_vm.date))]),
            _vm._v(" "),
            _c("span", { staticClass: "time" }, [_vm._v(_vm._s(_vm.time))]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }